<div class="history-container">
    <mat-grid-list cols="1" rowHeight="40px">
        <mat-grid-tile class="file-list-item" *ngFor="let status of history | async">
            <div class="status-container">
                <app-integration-status class="integration-status" [status]="status"></app-integration-status>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
</div>